import { React, useState } from 'react';
import PropTypes from 'prop-types';
import './tabbed-clickbox-menu.scss';

import { ClickboxMenu } from '../clickbox-menu/clickbox-menu';

export const TabbedClickboxMenu = ({ menuTabs, tabsContent, aria, ...props }) => {
  const [tabs, setTabs] = useState(menuTabs);

  const handleTabClick = (e, index) => {
    setTabs(
      tabs.map((tab, i) => {
        if (i === index) {
          if (!tab.active) {
            tab.active = true;
          }
        } else {
          tab.active = false;
        }
        return tab;
      })
    );
  };

  return (
    <div className="tabbed-clickbox-menu-component">
      <div className="tab-interface tabbed-clickbox-menu">
        <div
          role="tablist"
          aria-label={aria ? aria : 'Tablist'}
          className={`clickbox-menu-tablist ${
            tabs.filter((tab) => tab.active).length === 0 ? 'inactive' : ''
          }`}
        >
          {tabs.map((item, i) => {
            return (
              <button
                id={'tab-' + (i + 1)}
                key={'tab-' + (i + 1)}
                role="tab"
                aria-selected={item.active}
                aria-controls={'tabpanel-' + i}
                aria-label={`View ${item.label} Tab`}
                className={`clickbox-menu-tab ${item.active ? 'active' : ''}`}
                onClick={(e) => handleTabClick(e, i)}
              >
                {item.label}
              </button>
            );
          })}
        </div>
        <div className="tab-content">
          {tabs.map((item, i) => {
            return (
              <div
                id={'tabpanel-' + (i + 1)}
                key={'tabpanel-' + (i + 1)}
                role="tabpanel"
                aria-label={`${item.label}`}
                aria-labelledby={'tab-' + (i + 1)}
                className={`clickbox-menu-tabpanel ${!item.active ? 'display-none' : ''}`}
              >
                <ClickboxMenu menuItems={tabsContent[i]} aria={`${item.label} Data Menu`}/>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

TabbedClickboxMenu.propTypes = {
  menuTabs: PropTypes.arrayOf(PropTypes.object),
  tabsContent: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)),
  aria: PropTypes.string
};